// 不在左侧菜单中，但是在Main组件的子页面中显示的路由定义在这个文件中

import Main from '../manager/manager_index.vue'

// 首页
const homeIndex = {
  name: 'home_index',
  path: 'home',
  component: (resolve) => require(['../components/home/home.vue'], resolve)
}

// 修改密码
const updatePassword = {
  name: 'updatePassword',
  path: 'updatePassword',
  title: '修改密码',
  component: (resolve) => require(['../components/update_password.vue'], resolve)
}

// 刷新组件时使用的过渡组件
const loading = {
  path: '/loading',
  name: 'loading',
  component: (resolve) => require(['../components/loading/loading.vue'], resolve)
}

// 新增grid配置
const addGridConfig = {
  path: '/sa/grid/addGridConfig',
  name: 'addGridConfig',
  component: (resolve) => require(['../super-admin/grid-manage/index.vue'], resolve)
}

// 编辑grid配置
const editGridConfig = {
  path: '/sa/grid/manage',
  name: 'editGridConfig',
  component: (resolve) => require(['../super-admin/grid-manage/index.vue'], resolve)
}

// 新增站点配置
const addSiteConfig = {
  path: '/sa/site/addSiteConfig',
  name: 'addSiteConfig',
  meta: {
    url: '/superAdmin/siteManage/abstractGrid'
  },
  component: (resolve) => require(['../super-admin/site-manage/site-config-edit.vue'], resolve)
}

// 编辑站点配置
const editSiteConfig = {
  path: '/sa/site/editSiteConfig',
  name: 'editSiteConfig',
  meta: {
    url: '/superAdmin/siteManage/abstractGrid'
  },
  component: (resolve) => require(['../super-admin/site-manage/site-config-edit.vue'], resolve)
}

// 初始化站点数据
const siteInit = {
  path: '/sa/site/siteInit',
  name: 'siteInit',
  meta: {
    url: '/superAdmin/siteManage/siteInit'
  },
  component: (resolve) => require(['../super-admin/site-manage/site-init.vue'], resolve)
}

// 定义的路由需要添加到这个数组中
const childrenRouter = [
  homeIndex,
  updatePassword,
  loading,
  addGridConfig,
  editGridConfig,
  addSiteConfig,
  editSiteConfig,
  siteInit
]

const mainRouter = {
  path: '/',
  name: 'mainRouter',
  redirect: '/home',
  component: Main,
  children: [
    ...childrenRouter
  ]
}

export default mainRouter



// WEBPACK FOOTER //
// ./src/router/main-routers.js